// components/MenuItemsTable/CategorySection.js
import React from 'react';
import './CategorySection.css'

const CategorySection = ({
  subCategories,
  categoriesLoading,
  selectedCategory,
  onCategoryClick
}) => {
  const allCategory = {
    categoryName: 'ALL',
    dishId: null,
    image: 'https://cdn-icons-png.flaticon.com/512/1046/1046784.png'
  };

  return (
    <div 
  className="category-section-vikash" 
  style={{ 
    marginBottom: '20px', 
    padding: '0 12px',

    position: "sticky",
    top: "70px",   // 👈 mobile ke liye safe value
    zIndex: 999,
    background: "#fff",
    
  }}
>
      <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '12px', color: '#333' }}>
        Explore Categories
      </h3>

      {categoriesLoading ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '20px',
            height: '20px',
            border: '2px solid #f3f3f3',
            borderTop: '2px solid #ee6521',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <span>Loading categories...</span>
        </div>
      ) : (
        <div style={{
          display: 'flex',
          gap: '12px',
          overflowX: 'auto',
          paddingBottom: '8px',
          scrollbarWidth: "none"
        }}>
          {[allCategory, ...subCategories].map(cat => (
  <div
    key={cat.dishId || cat.categoryName}
    onClick={() => onCategoryClick(cat)}
    style={{
      display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minWidth: "70px",
  maxWidth: "70px",
  cursor: "pointer",
  padding: "6px 4px",
  flexShrink: 0,
    }}
  >
    <div style={{
      width: "56px",
    height: "56px",
    borderRadius: "50%",
    overflow: "hidden",
    marginBottom: "8px",
    border:
      selectedCategory === cat.dishId
        ? "2px solid #ee6521"
        : "2px solid #e5e5e5",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    background: "#fff",
    }}>
      <img
        src={cat.dishImage || cat.image}
        alt={cat.dishName}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        onError={e => {
          e.target.src = "https://cdn-icons-png.flaticon.com/512/1046/1046784.png";
        }}
      />
    </div>

    <p
  style={{
    width: "60px",
    fontSize: "12px",
    fontWeight: selectedCategory === cat.dishId ? "600" : "400",
    color: selectedCategory === cat.dishId ? "#ee6521" : "#333",
    margin: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: "16px",
  }}
  title={cat.categoryName === "ALL" ? "All" : cat.dishName}
>
  {cat.categoryName === "ALL" ? "All" : cat.dishName}
</p>
  </div>
))}
        </div>
      )}

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default CategorySection;